var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row margin-bottom-20" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-md-4 control-label" }, [
            _vm._v(_vm._s(_vm._f("trans")("job.create.fields.file")) + ":")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8" },
            [
              _c("upload-file-manual", {
                ref: "uploadFileManual",
                attrs: {
                  errors: _vm.form.options.errors,
                  accept: ".csv",
                  name: "file"
                },
                model: {
                  value: _vm.form.entity.file,
                  callback: function($$v) {
                    _vm.$set(_vm.form.entity, "file", $$v)
                  },
                  expression: "form.entity.file"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("label", { staticClass: "col-md-3 control-label" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("trans")("job.create.fields.discount_code")) +
              ":\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("single-select", {
              attrs: {
                "allow-empty": false,
                checked: _vm.form.entity.discountCodeId,
                options: _vm.formattedDiscountCodes,
                label: "label",
                name: "jobTypes"
              },
              model: {
                value: _vm.form.entity.discountCodeId,
                callback: function($$v) {
                  _vm.$set(_vm.form.entity, "discountCodeId", $$v)
                },
                expression: "form.entity.discountCodeId"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-actions" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "btn-set pull-right" }, [
            _c(
              "button",
              {
                staticClass: "btn green-jungle button-save margin-right-10",
                attrs: { type: "button" },
                on: { click: _vm.submitForm }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("form.save_and_close")) +
                    "\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn default",
                attrs: { type: "button" },
                on: { click: _vm.showList }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("form.cancel")) +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47a21b3f", { render: render, staticRenderFns: staticRenderFns })
  }
}